import { NgIf } from '@angular/common';
import * as i0 from '@angular/core';
import { inject, Component, ChangeDetectionStrategy, Input, HostBinding } from '@angular/core';
import { NgDocIconComponent } from '@ng-doc/ui-kit/components/icon';
import { NgDocCheckedChangeDirective } from '@ng-doc/ui-kit/directives/checked-change';
import { NgDocFocusableDirective } from '@ng-doc/ui-kit/directives/focusable';
import { DIStateControl, injectHostControl, DICompareHost } from 'di-controls';
const _c0 = [[["ng-doc-icon"]], "*"];
const _c1 = ["ng-doc-icon", "*"];
function NgDocCheckboxComponent_ng_doc_icon_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 8);
  }
}
function NgDocCheckboxComponent_ng_doc_icon_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ng-doc-icon", 9);
  }
}
let NgDocCheckboxComponent = /*#__PURE__*/(() => {
  class NgDocCheckboxComponent extends DIStateControl {
    constructor() {
      super({
        host: injectHostControl({
          optional: true
        }),
        compareHost: inject(DICompareHost, {
          optional: true
        })
      });
      this.color = 'primary';
    }
    static {
      this.ɵfac = function NgDocCheckboxComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || NgDocCheckboxComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: NgDocCheckboxComponent,
        selectors: [["ng-doc-checkbox"]],
        hostVars: 1,
        hostBindings: function NgDocCheckboxComponent_HostBindings(rf, ctx) {
          if (rf & 2) {
            i0.ɵɵattribute("data-lu-color", ctx.color);
          }
        },
        inputs: {
          color: "color"
        },
        features: [i0.ɵɵInheritDefinitionFeature],
        ngContentSelectors: _c1,
        decls: 10,
        vars: 5,
        consts: [[1, "ng-doc-checkbox-wrapper"], [1, "ng-doc-checkbox"], ["type", "checkbox", 3, "ngDocCheckedChange", "blur", "disabled", "ngDocChecked", "ngDocFocusable"], ["icon", "minus", 4, "ngIf"], ["icon", "check", 4, "ngIf"], [1, "ng-doc-checkbox-content"], [1, "ng-doc-checkbox-icons"], [1, "ng-doc-checkbox-text"], ["icon", "minus"], ["icon", "check"]],
        template: function NgDocCheckboxComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef(_c0);
            i0.ɵɵelementStart(0, "label", 0)(1, "div", 1)(2, "input", 2);
            i0.ɵɵlistener("ngDocCheckedChange", function NgDocCheckboxComponent_Template_input_ngDocCheckedChange_2_listener() {
              ctx.toggle();
              return ctx.touch();
            })("blur", function NgDocCheckboxComponent_Template_input_blur_2_listener() {
              return ctx.touch();
            });
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, NgDocCheckboxComponent_ng_doc_icon_3_Template, 1, 0, "ng-doc-icon", 3)(4, NgDocCheckboxComponent_ng_doc_icon_4_Template, 1, 0, "ng-doc-icon", 4);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(5, "div", 5)(6, "span", 6);
            i0.ɵɵprojection(7);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(8, "div", 7);
            i0.ɵɵprojection(9, 1);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("disabled", ctx.disabled)("ngDocChecked", ctx.checked())("ngDocFocusable", false);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isIntermediate);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.checked());
          }
        },
        dependencies: [NgDocCheckedChangeDirective, NgDocFocusableDirective, NgIf, NgDocIconComponent],
        styles: ["[_nghost-%COMP%]{display:inline-flex;align-items:flex-start;flex-direction:column;font-family:var(--ng-doc-font-family);font-variant:no-contextual;color:var(--ng-doc-text);line-height:var(--ng-doc-line-height);font-size:var(--ng-doc-font-size);font-weight:var(--ng-doc-font-weight)}[_nghost-%COMP%]:not(:last-of-type){margin-bottom:var(--ng-doc-list-element-vertical-space);margin-right:var(--ng-doc-list-element-horizontal-space)}[_nghost-%COMP%]:hover:not([data-checked=true])   .ng-doc-checkbox[_ngcontent-%COMP%]{border:var(--ng-doc-checkbox-border-hover)}[_nghost-%COMP%]:not([data-disabled=true])   .ng-doc-checkbox-wrapper[_ngcontent-%COMP%]{cursor:pointer}[data-checked=true][_nghost-%COMP%]   .ng-doc-checkbox[_ngcontent-%COMP%]{background-color:var(--ng-doc-checkbox-color);--ng-doc-checkbox-border: var(--ng-doc-checkbox-color);--ng-doc-checkbox-border-hover: var(--ng-doc-checkbox-color);--ng-doc-icon-color: var(--ng-doc-checkbox-color-text)}input[_ngcontent-%COMP%]{position:absolute;bottom:0;left:50%;border:0;clip:rect(0 0 0 0);height:1px;margin:-1px;overflow:hidden;padding:0;width:1px;outline:0}.ng-doc-checkbox-wrapper[_ngcontent-%COMP%]{display:flex}.ng-doc-checkbox[_ngcontent-%COMP%]{position:relative;display:flex;align-items:center;justify-content:center;width:calc(var(--ng-doc-base-gutter) * 2 + var(--ng-doc-base-gutter) / 2);height:calc(var(--ng-doc-base-gutter) * 2 + var(--ng-doc-base-gutter) / 2);border:var(--ng-doc-checkbox-border);flex:0 0 calc(var(--ng-doc-base-gutter) * 2 + var(--ng-doc-base-gutter) / 2);background-color:var(--ng-doc-base-0);transition:background-color var(--ng-doc-transition);box-sizing:border-box;border-radius:calc(var(--ng-doc-base-gutter) / 2)}.ng-doc-checkbox-content[_ngcontent-%COMP%]{display:flex;align-items:flex-start}.ng-doc-checkbox-icons[_ngcontent-%COMP%]{display:flex;margin-left:var(--ng-doc-base-gutter);margin-top:calc(var(--ng-doc-base-gutter) / 2)}.ng-doc-checkbox-icons[_ngcontent-%COMP%]:empty{display:none}.ng-doc-checkbox-text[_ngcontent-%COMP%]{margin-left:var(--ng-doc-base-gutter);line-height:calc(var(--ng-doc-base-gutter) * 2 + var(--ng-doc-base-gutter) / 2)}.ng-doc-checkbox-text[_ngcontent-%COMP%]:empty{display:none}"],
        changeDetection: 0
      });
    }
  }
  return NgDocCheckboxComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NgDocCheckboxComponent };
